<style>
    label {
        font-weight: unset;
    }
</style>

<template>

    <div>
        <table>
            <tr>
                <td>
                    <div>
                        <!-- PIX INICIO -->
                        <table>
                            <tr>
                                <td>
                                    <img src="/assets/images/pix-logo.png" style=" z-index: 200; position: absolute; top: 50px; left: 250px; width: 200px;">
                                    <div style="font-size:15px;font-weight:600;margin:4px 45px">PAGAMENTO PIX: obtenha a chave através do QRcode ou clique no botão Copiar chave</div>
                                    <div style="font-size:15px;font-weight:600;margin:20px 50px;border:1px solid #000000;padding:15px 30px;width:150px;text-align:center">
                                        Valor do Documento:
                                        {{pevValorNf}}
                                    </div>
                                </td>
                                <td>
                                    <img :src="dupQrCode"  style="width: 105px; left: 505px; top: 35px; position: absolute;"/>
                                    <input type="hidden" id="DupCopiaColaPix" :value="DupCopiaColaPix">
                                        <button class="button-38" role="button" style="width: 105px; left: 505px; top: 150px; position: absolute;" @click="copyTestingCode"> Copiar chave</button>
                                </td>
                            </tr>
                        </table>
                        <hr style="width:720px;border-top:1px dashed #000000" />
                    </div>
                </td>
            </tr>
        </table>
        <table style="position:relative;width:100%;height:800px">
            <tr>
                <td>
                    <!-- Grade da duplicata INICIO -->
                    <div class="hl" style="z-index: 134; left: 0; width: 720px; position: absolute; top: 70px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 135; left: 0; width: 720px; position: absolute; top: 94px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 136; left: 0; width: 720px; position: absolute; top: 118px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 137; left: 0; width: 720px; position: absolute; top: 142px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 138; left: 0; width: 720px; position: absolute; top: 166px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 139; left: 500px; width: 220px; position: absolute; top: 190px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 140; left: 0; width: 720px; position: absolute; top: 289px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 141; left: 0; width: 720px; position: absolute; top: 334px; height: 1px">
                    </div>
                    <div class="hl_riscado" style="z-index: 142; left: 0; width: 720px; position: absolute; top: 366px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 143; left: 0; width: 720px; position: absolute; top: 415px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 144; left: 0; width: 720px; position: absolute; top: 438px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 145; left: 0; width: 720px; position: absolute; top: 462px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 146; left: 0; width: 720px; position: absolute; top: 486px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 147; left: 0; width: 720px; position: absolute; top: 510px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 148; left: 498px; width: 222px; position: absolute; top: 534px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 149; left: 0; width: 720px; position: absolute; top: 630px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 152; left: 498px; width: 222px; position: absolute; top: 214px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 153; left: 498px; width: 222px; position: absolute; top: 238px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 154; left: 498px; width: 222px; position: absolute; top: 262px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 155; left: 498px; width: 222px; position: absolute; top: 558px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 156; left: 498px; width: 222px; position: absolute; top: 582px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 157; left: 498px; width: 222px; position: absolute; top: 606px; height: 1px">
                    </div>
                    <div class="hl" style="z-index: 150; left: 0; width: 720px; position: absolute; top: 673px; height: 1px">
                    </div>
                    <div class="hl_riscado" style="z-index: 151; left: 0; width: 720px; position: absolute; top: 773px; height: 1px">
                    </div>
                    <div style="left: 498px; z-index: 159; position: absolute; top: 71px; height: 218px; width: 1px;"
                         class="vl">
                    </div>
                    <div style="left: 498px; z-index: 160; position: absolute; top: 416px; height: 214px; width: 1px;"
                         class="vl">
                    </div>
                    <div class="vl" style="z-index: 161; left: 210px; width: 1px; position: absolute; top: 46px; height: 25px">
                    </div>
                    <div class="vl" style="z-index: 162; left: 272px; width: 1px; position: absolute; top: 46px; height: 25px">
                    </div>
                    <div class="vl" style="z-index: 161; left: 210px; width: 1px; position: absolute; top: 390px; height: 25px">
                    </div>
                    <div class="vl" style="z-index: 162; left: 272px; width: 1px; position: absolute; top: 390px; height: 25px">
                    </div>
                    <div class="vl" style="z-index: 163; left: 110px; width: 1px; position: absolute; top: 118px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 164; left: 249px; width: 1px; position: absolute; top: 118px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 165; left: 346px; width: 1px; position: absolute; top: 118px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 166; left: 418px; width: 1px; position: absolute; top: 118px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 167; left: 104px; width: 1px; position: absolute; top: 142px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 168; left: 249px; width: 1px; position: absolute; top: 142px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 170; left: 382px; width: 1px; position: absolute; top: 142px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 173; left: 110px; width: 1px; position: absolute; top: 462px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 174; left: 249px; width: 1px; position: absolute; top: 462px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 175; left: 346px; width: 1px; position: absolute; top: 462px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 176; left: 418px; width: 1px; position: absolute; top: 462px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 177; left: 382px; width: 1px; position: absolute; top: 486px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 178; left: 249px; width: 1px; position: absolute; top: 486px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 179; left: 177px; width: 1px; position: absolute; top: 486px; height: 24px">
                    </div>
                    <div class="vl" style="z-index: 180; left: 104px; width: 1px; position: absolute; top: 486px; height: 24px">
                    </div>

                    <!-- Grade da duplicata FIM -->
                    <!-- Títulos dos campos INICIO -->
                    <span class="Times9" style="z-index: 185; left: 609px; position: absolute; top: 57px">
                        Recibo do
                        <label class="Times7" ID="lblSacado0" v-if="dupBanco.substring(0, 3) === '237' || dupBanco.substring(0, 3) === '399'">Pagador</label>
                        <label class="Times7" ID="lblSacado0" v-else>Pagador</label>  <!-- sacado? -->
                    </span>
                    <span class="Times7" style="z-index: 188; left: 9px; position: absolute; top: 70px">Local de Pagamento </span>
                    <span class="Times7" style="z-index: 191; left: 505px; position: absolute; top: 70px">Vencimento até</span>
                    <span class="Times7" style="z-index: 193; left: 9px; position: absolute; top: 94px">
                        <label class="Times7">Beneficiario</label>
                    </span>
                    <span class="Times7" style="z-index: 195; left: 505px; position: absolute; top: 94px">
                        Agência/Código
                        <label class="Times7">Beneficiario</label>
                    </span>
                    <span class="Times7" style="z-index: 196; left: 9px; position: absolute; top: 118px">Data do Documento</span>
                    <span class="Times7" style="z-index: 199; left: 121px; position: absolute; top: 118px">Nº do Documento</span>
                    <span class="Times7" style="z-index: 201; left: 257px; position: absolute; top: 118px">Espécie Doc.</span>
                    <span class="Times7" style="z-index: 203; left: 353px; position: absolute; top: 118px">Aceite</span>
                    <span class="Times7" style="z-index: 204; left: 425px; position: absolute; top: 118px">Data Proces.</span>
                    <span class="Times7" style="z-index: 206; left: 505px; position: absolute; top: 118px">Nosso Número</span>
                    <span class="Times7" style="z-index: 209; left: 9px; position: absolute; top: 142px">Uso do Banco</span>
                    <span class="Times7" style="z-index: 211; left: 113px; position: absolute; top: 142px">Carteira</span>
                    <span class="Times7" style="z-index: 213; left: 185px; position: absolute; top: 142px">Espécie</span>
                    <span class="Times7" style="z-index: 215; left: 256px; position: absolute; top: 142px">Quantidade</span>
                    <span class="Times7" style="z-index: 216; left: 393px; position: absolute; top: 142px">(x) Valor</span>
                    <span class="Times7" style="z-index: 218; left: 505px; position: absolute; top: 142px">(=) Valor do Documento</span>
                    <span class="Times7" style="z-index: 226; left: 505px; position: absolute; top: 166px">(-) Desconto/Abatimento</span>

                    <span class="Times7" style="z-index: 231; left: 505px; position: absolute; top: 190px">(-) Outras Deduções</span>
                    <span class="Times7" style="z-index: 232; left: 505px; position: absolute; top: 214px">(+) Mora/Multa</span>
                    <span class="Times7" style="z-index: 234; left: 505px; position: absolute; top: 238px">(+) Outros Acrescimos</span>
                    <span class="Times7" style="z-index: 236; left: 505px; position: absolute; top: 262px">(=) Valor Cobrado</span>
                    <span class="Times7" style="z-index: 239; left: 9px; position: absolute; top: 288px">
                        <label class="Times7" v-if="dupBanco.substring(0, 3) === '237' || dupBanco.substring(0, 3) === '399'">Pagador</label>
                        <label class="Times7" v-else>Pagador</label>  <!-- sacado? -->
                    </span>
                    <span class="Times7" style="z-index: 242; left: 9px; position: absolute; top: 323px">
                        <label class="Times7" v-if="dupBanco.substring(0, 3) === '237' || dupBanco.substring(0, 3) === '399'">Pagador</label>
                        <label class="Times7" v-else>Pagador</label>  <!-- sacado? -->/Avalista
                    </span>
                    <span class="Times7" style="z-index: 189; left: 9px; position: absolute; top: 414px">Local de Pagamento </span>
                    <span class="Times7" style="z-index: 190; left: 505px; position: absolute; top: 414px">Vencimento até</span>
                    <span class="Times7" style="z-index: 192; left: 9px; position: absolute; top: 438px">
                        <label class="Times7">Beneficiario</label>
                    </span>
                    <span class="Times7" style="z-index: 194; left: 505px; position: absolute; top: 438px">
                        Agência/Código
                        <label class="Times7">Beneficiario</label>
                    </span>
                    <span class="Times7" style="z-index: 197; left: 9px; position: absolute; top: 462px">Data do Documento</span>
                    <span class="Times7" style="z-index: 198; left: 121px; position: absolute; top: 462px">Nº do Documento</span>
                    <span class="Times7" style="z-index: 200; left: 257px; position: absolute; top: 462px">Espécie Doc.</span>
                    <span class="Times7" style="z-index: 202; left: 353px; position: absolute; top: 462px">Aceite</span>
                    <span class="Times7" style="z-index: 205; left: 425px; position: absolute; top: 462px">Data Proces.</span>
                    <span class="Times7" style="z-index: 207; left: 505px; position: absolute; top: 462px">Nosso Número</span>
                    <span class="Times7" style="z-index: 208; left: 9px; position: absolute; top: 486px">Uso do Banco</span>
                    <span class="Times7" style="z-index: 210; left: 113px; position: absolute; top: 486px">Carteira</span>
                    <span class="Times7" style="z-index: 212; left: 185px; position: absolute; top: 486px">Espécie</span>
                    <span class="Times7" style="z-index: 214; left: 256px; position: absolute; top: 486px">Quantidade</span>
                    <span class="Times7" style="z-index: 217; left: 393px; position: absolute; top: 486px">(x) Valor</span>
                    <span class="Times7" style="z-index: 219; left: 505px; position: absolute; top: 486px">(=) Valor do Documento</span>
                    &nbsp; &nbsp;
                    <span class="Times7" style="z-index: 227; left: 505px; position: absolute; top: 510px">(-) Desconto/Abatimento</span>





                    <span class="Times7" style="z-index: 230; left: 505px; position: absolute; top: 534px">(-) Outras Deduções</span>
                    <span class="Times7" style="z-index: 233; left: 505px; position: absolute; top: 558px">(+) Mora/Multa</span>
                    <span class="Times7" style="z-index: 235; left: 505px; position: absolute; top: 582px">(+) Outros Acrescimos</span>
                    <span class="Times7" style="z-index: 237; left: 505px; position: absolute; top: 606px">(=) Valor Cobrado</span>
                    <span class="Times7" style="z-index: 238; left: 9px; position: absolute; top: 630px">
                        <label class="Times7" v-if="dupBanco.substring(0, 3) === '237' || dupBanco.substring(0, 3) === '399'">Pagador</label>
                        <label class="Times7" v-else>Pagador</label>
                    </span>
                    <span class="Times8" style="z-index: 240; left: 467px; position: absolute; top: 675px">Autenticação Mecânica</span>
                    <span class="Times7" style="z-index: 241; left: 9px; position: absolute; top: 662px">
                        <label class="Times7" v-if="dupBanco.substring(0, 3) === '237' || dupBanco.substring(0, 3) === '399'">Pagador</label>
                        <label class="Times7" v-else>Pagador</label>/Avalista
                    </span>
                    <span class="Times9" style="z-index: 243; left: 596px; position: absolute; top: 674px">Ficha de Compensação</span>
                    <span class="Times9" style="z-index: 244; left: 635px; position: absolute; top: 654px">Código de Baixa</span>

                    <label ID="beneficiarioEndereco" runat="server" class="Times7" style="line-height: 8px; z-index: 245; left: 9px; position: absolute; top: 102px; width: 483px;">{{beneficiarioEndereco}}</label>
                    <label ID="beneficiarioEndereco_1" runat="server" class="Times7" style="line-height: 8px; z-index: 246; left: 9px; position: absolute; top: 446px; width: 483px;">{{beneficiarioEndereco}}</label>

                    <!-- Títulos dos campos FIM -->
                    <!-- Labels EM CIMA INICIO -->
                    <img src="/assets/images/logo-bb.png" style="z-index: 200; position: absolute; top: -18px; left: -21px; width: 229px;">
                    <label ID="BANCO" runat="server" style="z-index: 100; left: 9px; position: absolute; top: 55px"
                           class="Times11B"> {{ banco }} </label>
                    <label ID="DUP_BANCO" runat="server" class="Times11B" style="z-index: 101; left: 222px; position: absolute; top: 55px">{{dupBanco}}</label>

                    <label ID="DUP_LOCALPGTO" runat="server" class="Times7" style="z-index: 102; left: 9px; position: absolute; top: 83px" v-html="dupLocalPgto"></label>
                    <label ID="DUP_VENCIMENTO" runat="server" class="Times8B" style="z-index: 104; left: 510px; position: absolute; top: 82px; width: 116px;">{{dupVencimento}}</label>
                    <label ID="DUP_AGENCIACEDENTE" runat="server" class="Times7" style="z-index: 105; left: 510px; position: absolute; top: 107px">{{dupAgenciaAcedente}}</label>
                    <label ID="DUP_DATADOCUMENTO" runat="server" class="Times7B" style="z-index: 106; left: 9px; position: absolute; top: 131px">{{dupDataDocumento}}</label>
                    <label ID="DUP_DOCUMENTO" runat="server" class="Times7B" style="z-index: 107; left: 121px; position: absolute; top: 131px">{{dupDocumento}}</label>
                    <label ID="DUP_DATADOCUMENTO_2" runat="server" class="Times7" style="z-index: 108; left: 425px; position: absolute; top: 131px">{{dupDataDocumento}}</label>
                    <label ID="DUP_NOSSONUMERO" runat="server" class="Times7B" style="z-index: 109; left: 510px; position: absolute; top: 131px">{{dupNossoNumero}}</label>
                    <label ID="DUP_CARTEIRA" runat="server" class="Times7" style="z-index: 110; left: 113px; position: absolute; top: 155px">{{dupCarteira}}</label>
                    <label ID="DUP_MOEDA" runat="server" class="Times7" style="z-index: 111; left: 185px; position: absolute; top: 155px">{{dupMoeda}}</label>
                    <label ID="PEV_VALORNF" runat="server" class="Times8B" style="z-index: 112; left: 510px; position: absolute; top: 154px">{{pevValorNf}}</label>
                    <label ID="DUP_DOCUMENTO" runat="server" class="Times7B" style="z-index: 107; left: 121px; position: absolute; top: 271px">{{MensVenc}}</label>
                    <div style="z-index: 25; position: absolute; left: 8px; top: 203px; width: 440px; height: 14PX;">
                        <label ID="MensDescr1_1" runat="server" class="Times8B" v-html="mensDescr1"></label><br>
                        <label ID="MensDescr2" runat="server" class="Times8B"></label><br>
                    </div>
                    <span style="z-index: 250; left: 9px; position: absolute; top: 299px;" class="Times7">
                        <label class="Times7" ID="CLI_CODIGO" runat="server" />{{cliCodigo}}-{{cliCodigoDv}}<label ID="CLI_CODIGODV" runat="server" />
                        <label class="Times7" ID="DUP_RAZAOSOCIAL" runat="server">{{dupRazaoSocial}}</label>
                    </span>
                    <label ID="DUP_ENDERECO" runat="server" style="z-index: 113; left: 9px; position: absolute; top: 310px"
                           class="Times7">{{dupEndereco}}</label>

                    <label ID="DUP_CGC" runat="server" style="z-index: 187; left: 385px; position: absolute; top: 299px"
                           class="Times7" Text="CGC:">CNPJ: {{dupCgc}}</label>
                    <span class="Times7" style="z-index: 184; left: 385px; position: absolute; top: 310px">
                        CEP:
                        <label class="Times7" ID="DUP_CEP" runat="server">{{dupCep}}</label>
                    </span>
                    <label ID="DUP_CIDADE" runat="server" style="z-index: 114; left: 522px; position: absolute; top: 299px"
                           class="Times7">{{dupCidade}}</label>
                    <label ID="DUP_ESTADO" runat="server" style="z-index: 115; left: 522px; position: absolute; top: 310px"
                           class="Times7">{{dupEstado}}</label>
                    <label ID="DOC_ESPECIE" runat="server" class="Times7" style="z-index: 132; left: 258px; position: absolute; top: 131px">{{docEspecie}}</label>
                    <label ID="ACEITE" runat="server" class="Times7" style="z-index: 133; left: 352px; position: absolute; top: 131px"></label>
                    &nbsp;
                    <!-- Labels Labels EM CIMA FIM -->
                    <!-- Labels EM BAIXO INICIO -->
                    <img src="/assets/images/logo-bb.png" style="z-index: 200; position: absolute; top: 326px; left: -21px; width: 229px;">
                    <label ID="BANCO_1" runat="server" style="z-index: 116; left: 9px; position: absolute; top: 399px"
                           class="Times11B">{{banco}}</label>
                    <label ID="DUP_BANCO_1" runat="server" class="Times11B" style="z-index: 117; left: 222px; position: absolute; top: 399px">{{dupBanco}}</label>
                    <label ID="LINHA_DIGITAVEL" runat="server" class="Times11B" style="z-index: 117; left: 282px; position: absolute; top: 399px">{{dupLinhaDigitavel}}</label>
                    <label ID="DUP_LOCALPGTO_1" runat="server" class="Times7" style="z-index: 118; left: 9px; position: absolute; top: 427px" v-html="dupLocalPgto"></label>
                    <label ID="DUP_VENCIMENTO_1" runat="server" class="Times8B" style="z-index: 120; left: 510px; position: absolute; top: 426px">{{dupVencimento}}</label>
                    <label ID="DUP_AGENCIACEDENTE_1" runat="server" class="Times7" style="z-index: 121; left: 510px; position: absolute; top: 451px">{{dupAgenciaAcedente}}</label>
                    <label ID="DUP_DATADOCUMENTO_1" runat="server" class="Times7B" style="z-index: 122; left: 9px; position: absolute; top: 475px">{{dupDataDocumento}}</label>
                    <label ID="DUP_DOCUMENTO_1" runat="server" class="Times7B" style="z-index: 123; left: 121px; position: absolute; top: 475px">{{dupDocumento}}</label>
                    <label ID="DUP_DATADOCUMENTO_3" runat="server" class="Times7" style="z-index: 124; left: 425px; position: absolute; top: 475px">{{dupDataDocumento}}</label>
                    <label ID="DUP_NOSSONUMERO_1" runat="server" class="Times7B" style="z-index: 125; left: 510px; position: absolute; top: 475px">{{dupNossoNumero}}</label>
                    <label ID="DUP_CARTEIRA_1" runat="server" class="Times7" style="z-index: 126; left: 113px; position: absolute; top: 499px">{{dupCarteira}}</label>
                    <label ID="DUP_MOEDA_1" runat="server" class="Times7" style="z-index: 127; left: 185px; position: absolute; top: 499px">{{dupMoeda}}</label>
                    <label ID="PEV_VALORNF_1" runat="server" class="Times8B" style="z-index: 128; left: 510px; position: absolute; top: 498px">{{pevValorNf}}</label>
                    <div style="z-index: 25; position: absolute; left: 8px; top: 548px; width: 440px; height: 14PX;">
                        <label ID="MensDescr1_1" runat="server" class="Times8B" v-html="mensDescr1"></label><br>
                        <label ID="MensDescr2_1" runat="server" class="Times8B" /><br>
                        <label ID="MensVenc_1" runat="server" class="Times8" />
                    </div>
                    <span style="z-index: 249; left: 9px; position: absolute; top: 642px;" class="Times7">
                        <label class="Times7" ID="CLI_CODIGO_1" runat="server">{{cliCodigo}}-{{cliCodigoDv}} </label>
                        <label class="Times7" ID="DUP_RAZAOSOCIAL_1" runat="server"> {{dupRazaoSocial}}</label>
                    </span>
                    <label ID="DUP_ENDERECO_1" runat="server" style="z-index: 129; left: 9px; position: absolute; top: 653px"
                           class="Times7">{{dupEndereco}}</label>
                    <label ID="DUP_CGC_1" runat="server" style="z-index: 186; left: 385px; position: absolute; top: 643px"
                           class="Times7" Text="CGC:">CNPJ: {{dupCgc}}</label>
                    <span class="Times7" style="z-index: 183; left: 385px; position: absolute; top: 654px">
                        CEP:
                        <label class="Times7" ID="DUP_CEP_1" runat="server">{{dupCep}}</label>
                    </span>
                    <label ID="DUP_CIDADE_1" runat="server" style="z-index: 130; left: 522px; position: absolute; top: 643px"
                           class="Times7">{{dupCidade}}</label>
                    <label ID="DUP_ESTADO_1" runat="server" style="z-index: 131; left: 522px; position: absolute; top: 654px"
                           class="Times7">{{dupEstado}}</label>
                    <label ID="DUP_LINHADIGITAVEL" runat="server" class="Times10B" style="z-index: 132; left: 281px; position: absolute; top: 401px"></label>
                    <label ID="DOC_ESPECIE_1" runat="server" class="Times7" style="z-index: 132; left: 257px; position: absolute; top: 475px"></label>
                    <label ID="ACEITE_1" runat="server" class="Times7" style="z-index: 133; left: 352px; position: absolute; top: 475px"></label>
                    &nbsp;
                    <!-- Labels Labels EM BAIXO FIM -->
                    <!--barcode v-bind:value="dupCodigoBarras" fontOptions='bold' width='1.5' height='58' text=' ' style="z-index: 1; left: 8px; width: 485px; position: absolute; top: 694px; height: 60px;"></barcode-->
                    <!--barcode fontOptions='bold' width='4' height='58' text=' ' style="z-index: 1; left: 8px; position: absolute; top: 694px; height: 60px;">{{dupCodigoBarras}}</barcode-->

                    <div id="barCode" style="z-index: 251; left: 8px; width: 455px; position: absolute; top: 694px; height: 60px;">
                        <span v-html="dupCodigoBarras"></span>
                    </div>
                    <!-- <div id="barCode" style="z-index: 251; left: 8px; width: 455px; position: absolute; top: 694px; height: 60px;"
                    runat="server">
                </div> -->

                    <div v-if="dupBanco.substring(0, 3) === '237'">
                        <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 168px">Instruções:</span>
                        <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 512px">Instruções:</span>
                    </div>

                    <div v-else>
                        <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 167px">Valor do Desconto:</span>
                        <span class="Times7" style="z-index: 224; left: 185px; position: absolute; top: 166px">Desconto Até</span>
                        <span class="Times7" style="z-index: 226; left: 310px; position: absolute; top: 166px">Com. Permanência por Dia</span>
                        <div class="vl" style="z-index: 190; left: 305px; width: 1px; position: absolute; top: 166px; height: 24px"></div>
                        <div class="vl" style="z-index: 169; left: 177px; width: 1px; position: absolute; top: 166px; height: 24px"></div>
                        <div class="hl" style="z-index: 138; left: 0; width: 720px; position: absolute; top: 190px; height: 1px"></div>
                        <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 190px">Instruções:</span>

                        <span class="Times7" style="z-index: 229; left: 9px; position: absolute; top: 511px">Valor do Desconto:</span>
                        <span class="Times7" style="z-index: 224; left: 185px; position: absolute; top: 511px">Desconto Até</span>
                        <span class="Times7" style="z-index: 226; left: 310px; position: absolute; top: 511px">Com. Permanência por Dia</span>
                        <div class="vl" style="z-index: 190; left: 305px; width: 1px; position: absolute; top: 510px; height: 24px"></div>
                        <div class="vl" style="z-index: 190; left: 177px; width: 1px; position: absolute; top: 510px; height: 24px"></div>
                        <div class="hl" style="z-index: 147; left: 0; width: 720px; position: absolute; top: 534px; height: 1px"></div>
                        <span class="Times7" style="z-index: 228; left: 9px; position: absolute; top: 534px">Instruções:</span>
                    </div>
                </td>
            </tr>
        </table>

    </div>
</template>
<style type="text/css">

    /* CSS */
    .button-38 {
        background-color: #FFFFFF;
        border: 0;
        border-radius: .5rem;
        box-sizing: border-box;
        color: #111827;
        font-family: "Inter var",ui-sans-serif,system-ui,-apple-system,system-ui,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
        font-size: .875rem;
        font-weight: 600;
        line-height: 1.25rem;
        padding: .75rem 1rem;
        text-align: center;
        text-decoration: none #D1D5DB solid;
        text-decoration-thickness: auto;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
        cursor: pointer;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
    }

    .button-38:hover {
        background-color: rgb(249,250,251);
    }

    .button-38:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
    }

    .button-38:focus-visible {
        box-shadow: none;
    }
</style>
<script>

    export default {
        name: 'FinancialTicketPaymentCash',
        data() {
            return {
                banco: '',
                dupBanco: '',
                dupLocalPgto: '',
                dupVencimento: '',
                dupAgenciaAcedente: '',
                dupDataDocumento: '',
                dupDocumento: '',
                dupNossoNumero: '',
                dupCarteira: '',
                dupMoeda: '',
                pevValorNf: '',
                mensDescr1: '',
                MensVenc: '',
                cliCodigo: '',
                cliCodigoDv: '',
                dupRazaoSocial: '',
                dupEndereco: '',
                dupCgc: '',
                dupCep: '',
                dupCidade: '',
                dupEstado: '',
                docEspecie: '',
                aceite: '',
                dupLinhaDigitavel: '',
                beneficiarioEndereco: '',
                dupCodigoBarras: '',
                dupQrCode: '',
                DupCopiaColaPix : ''
            }
        },
        methods: {
            pad: function (n, width, z) {
                z = z || '0';
                n = n + '';
                return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
            },
            copyTestingCode() {
                 // 不是  才能複製
                let testingCodeToCopy = document.querySelector('#DupCopiaColaPix')
                testingCodeToCopy.setAttribute('type', 'text')
                testingCodeToCopy.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                } catch (err) {
                }

                /* unselect the range */
                testingCodeToCopy.setAttribute('type', 'hidden')
                window.getSelection().removeAllRanges()
            },
            formatCurrency: function (v) {
                //formada coluna de valores da tabela para moeda
                var formato = {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL"
                };
                return parseFloat(v).toLocaleString("pt-BR", formato);
            }
        },
        updated() {
            this.DupCopiaColaPix = this.DupCopiaColaPix;
        },
        mounted() {
            const self = this
            let xhr = new XMLHttpRequest()
            xhr.onload = () => {
                if (xhr.status == 200) {
                    var dadosDuplicata = JSON.parse(xhr.responseText)
                    // Preenchendo o Boleto
                    this.dupBanco = dadosDuplicata.DupBanco;
                    this.cliCodigo = dadosDuplicata.CliCodigo;
                    this.cliCodigoDv = dadosDuplicata.CliCodigodv;
                    this.dupRazaoSocial = dadosDuplicata.DupRazaosocial;
                    this.dupEndereco = dadosDuplicata.DupEndereco;
                    this.dupCep = dadosDuplicata.DupCep.replace(/(\d{5})(\d{3})/g, "\$1\-\$2");
                    this.dupCidade = dadosDuplicata.DupCidade;
                    this.dupEstado = dadosDuplicata.DupEstado;
                    this.dupLinhaDigitavel = dadosDuplicata.DupLinhadigitavel;
                    this.dupCgc = dadosDuplicata.DupCgc;
                    this.dupNossoNumero = dadosDuplicata.DupNossonumero;
                    this.beneficiarioEndereco = "Descarbonize Soluções S/A CNPJ:" + dadosDuplicata.Empcnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5") + " ENDEREÇO:" + dadosDuplicata.Empendereco.replace("  ", " ") + " - BAIRRO:" + dadosDuplicata.Empbairro + " - CIDADE:" + dadosDuplicata.Empcidade + " - " + dadosDuplicata.Empuf;
                    this.dupVencimento = dadosDuplicata.DupVencimento.substring(0, 10);
                    this.dupCodigoBarras = dadosDuplicata.DupBar2;
                    this.dupAgenciaAcedente = dadosDuplicata.DupAgenciacedente;
                    this.dupDataDocumento = dadosDuplicata.DupDatadocumento;
                    this.dupDocumento = dadosDuplicata.DupDocumento;
                    this.dupCarteira = dadosDuplicata.DupCarteira;
                    this.dupMoeda = dadosDuplicata.DupMoeda;
                    this.dupQrCode = dadosDuplicata.DupQRCODE;
                    this.DupCopiaColaPix = dadosDuplicata.DupCopiaColaPix;
                    this.pevValorNf = self.formatCurrency(dadosDuplicata.PevValornf);
                    this.mensDescr1 = "* ATENÇÃO: NÃO ACEITAR PAGAMENTO APÓS " + dadosDuplicata.DupVencimento.substring(0, 10) + "." +
                        "<br>PEDIDO COM OS PREÇOS À VISTA COM VALIDADE ATÉ " + dadosDuplicata.DupVencimento.substring(0, 10);

                    if (dadosDuplicata.DupLocalpgto == '') {
                        this.dupLocalPgto = ''
                    }
                    else {
                        this.dupLocalPgto = dadosDuplicata.DupLocalpgto + "    " + dadosDuplicata.DupPreferencia.replace(" ", "&nbsp;");
                    }

                    if (dadosDuplicata.DupBanco.substring(0, 3) == '001') {
                        this.banco = 'BANCO DO BRASIL';
                    }
                    else if (dadosDuplicata.DupBanco.substring(0, 3) == '237') {
                        this.dupNossoNumero = this.dupNossoNumero.substring(0, 2) + "/"
                            + this.dupNossoNumero.substring(2, this.dupNossoNumero.length - 3) + "-"
                            + this.dupNossoNumero.substring(this.dupNossoNumero.length - 1);
                        this.banco = 'BRADESCO';
                    }
                    else {
                        this.banco = 'HSBC';
                    }

                    if (dadosDuplicata.DupNomeimpressao != '')
                        this.MensVenc = "Vendedor(a): " + dadosDuplicata.DupNomeimpressao;

                }
                else if (xhr.status == 401) {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning"
                    }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
                }
                else if (xhrBanco.status == 404) {
                    swal({
                        title: "Duplicata não enviada ao Banco ou inexistente!",
                        icon: "warning"
                    }).then(() => location.href = `${self.$SiteUrl}/Financeiro/boleto`)
                }
            }

            xhr.open("POST", this.$apiUrl + "Financeiro.svc/duplicatavista")
            xhr.setRequestHeader("Content-type", "application/json")
            xhr.withCredentials = true
            xhr.send(JSON.stringify({
                nnumero: this.$route.params.numero
            }))
        }
    }
</script>
